import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getAccounts } from '../../services/accountService';

// Async thunk for fetch accounts
export const fetchAccounts = createAsyncThunk('account/fetchAccounts', async (_, thunkAPI) => {
    try {
        const state = thunkAPI.getState().account;
        const { filters, page, sort_by, sort_order, per_page } = state;
        const params = { ...filters, page, sort_by, sort_order, per_page };
        const response = await getAccounts(params);
        const data = response.data;
        return data;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.response.data);
    }
});

// Initial state
const initialState = {
    accounts: [],
    pagination: {},
    loading: false,
    error: null,
    filters: {
        url: '',
        account: '',
        label: '',
        active_for_telegram: ''
    },
    sort_by: 'last_alert_date',
    sort_order: 'desc',
    page: 1,
    per_page: 10 
};

const accountSlice = createSlice({
    name: 'account',
    initialState,
    reducers: {
        refresh(state) {
            Object.assign(state, initialState);
        },
        setFilters(state, action) {
            state.filters = { ...state.filters, ...action.payload };
            state.page = 1;
        },
        setSort(state, action) {
            const sort = action.payload;
            const [sort_by, sort_order] = sort.split('|');
            state.sort_by = sort_by;
            state.sort_order = sort_order;
        },
        setPage(state, action) {
            state.page = action.payload;
        },   
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAccounts.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchAccounts.fulfilled, (state, action) => {  
                state.accounts = action.payload.data;
                state.pagination = {
                    current_page: action.payload.current_page,
                    last_page: action.payload.last_page,
                    per_page: action.payload.per_page,
                    total: action.payload.total,
                };
                state.loading = false;
            })
            .addCase(fetchAccounts.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const { refresh, setFilters, setSort, setPage } = accountSlice.actions;
export default accountSlice.reducer;


